<template>
  <div class="sign-up_container">
    <UrgentBanner
      type="Error !!"
      message="Unable to verify your account. Please retry logging in."
      v-if="showBanner === true"
    />
    <form class="sign-up_form">
      <div class="wcf-details_container">
        <img id="wcf-logo" src="../assets/logo.png" />
        <p class="wcf-text">Winners Campus Fellowship</p>
      </div>
      <div class="form-details">
        <h2 class="form-header">Create your account</h2>
        <div class="form-field">
          <label for="Full name">Full name</label>
          <input
            name="Full name"
            type="text"
            value=""
            placeholder="Full name"
          />
        </div>
        <div class="form-field">
          <label for="Phone number">Phone number</label>
          <input
            name="Phone number"
            type="text"
            value=""
            placeholder="Phone number"
          />
        </div>
        <div class="form-field">
          <label for="Email">Email</label>
          <input name="Email" type="text" value="" placeholder="Email" />
        </div>
        <div class="form-field">
          <label for="Date of birth">Date of birth</label>
          <input
            name="Date of birth"
            type="text"
            value=""
            placeholder="Date of Birth"
          />
        </div>
        <div class="form-field">
          <label for="Department">Department</label>
          <input
            name="Department"
            type="text"
            value=""
            placeholder="Department"
          />
        </div>
        <div class="form-field">
          <label for="Level">Level</label>
          <input name="Level" type="text" value="" placeholder="Level" />
        </div>
      </div>
      <div class="submit-details">
        <input type="submit" value="Create account" />
        <p class="instruction-text">
          After your account is created, you will be taken to the sign in page
          where you are required to enter your email to sign in to your newly
          created account
        </p>
      </div>
    </form>
  </div>
</template>

<script>
// @ is an alias to /src
import UrgentBanner from "@/components/UrgentBanner.vue";

export default {
  name: "SignUp",
  data() {
    return {
      showBanner: false,
    };
  },
  components: {
    UrgentBanner,
  },
};
</script>

<style lang="scss" scoped>
:root {
  --font-size-small: 0.926vw;
  --font-size-medium: 2.778vw;
  --black: #000;
  --grey: rgba(0, 0, 0, 0.7);
  --light-grey: rgba(0, 0, 0, 0.5);
  --least-heavy: 400;
  --medium-heavy: 500;
  --heavy: 700;
  --vertical-gap: 2.149vh;
  --horizontal-gap: 1.389vw;
  --accent-colour: #f40200;
}

.sign-up_container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  form.sign-up_form {
    width: fit-content;
    height: fit-content;
    display: flex;
    flex-direction: column;
    max-width: 51.389vw;
    align-items: center;
    .wcf-details_container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: var(--vertical-gap);
      img {
        width: 4.34vw;
        height: auto;
      }
      p {
        color: var(--grey);
        font-family: "DM Sans";
        font-size: var(--font-size-small);
        font-style: normal;
        font-weight: var(--least-heavy);
        line-height: normal;
      }
    }
    .form-details {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: var(--vertical-gap);
      padding: var(--vertical-gap) var(--horizontal-gap);
      h2 {
        color: var(--black);
        font-family: "DM Sans";
        font-size: var(--font-size-medium);
        font-style: normal;
        font-weight: var(--medium-heavy);
        line-height: normal;
        letter-spacing: -0.111vw;
        grid-column: 1 / span 2;
        text-align: center;
      }
      .form-field {
        display: flex;
        flex-direction: column;
        gap: var(--vertical-gap);
        align-items: flex-start;
      }
    }
    .submit-details {
      max-width: 27.083vw;
      padding: var(--vertical-gap) var(--horizontal-gap);
      display: flex;
      flex-direction: column;
      gap: var(--vertical-gap);
      align-items: center;
      input {
        border-radius: 0.926vw;
        background: var(--accent-colour);
        color: var(--white);
        font-size: 0.926vw;
        font-family: "DM Sans", Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: var(--heavy);
        line-height: normal;
        letter-spacing: -0.037vw;
        width: fit-content;
        border: none;
        padding: var(--vertical-gap) var(--horizontal-gap);
      }
      p.instruction-text {
        color: var(--light-grey);
        text-align: center;
        font-family: "DM Sans";
        font-size: var(--font-size-tiny);
        font-style: normal;
        font-weight: var(--least-heavy);
        line-height: normal;
      }
    }
  }
}
</style>
